import { GroupsService } from './groups.service';
import { Component, AfterViewInit, OnInit } from '@angular/core';

import * as Prism from 'prismjs';
import {
  ListGruppiStudioDTO,
  SelectDTO,
  UtenteDTO,
  StudenteDTO,
} from 'src/app/model/newModel';
import { Router } from '@angular/router';
import { SharedService } from 'src/app/shared/shared.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AbstractListComponent } from '../../../model/AbstractListComponent';

@Component({
  selector: 'app-groups',
  templateUrl: './groups.component.html',
  styleUrls: ['./groups.component.css'],
})
export class GroupsComponent
  extends AbstractListComponent
  implements AfterViewInit, OnInit {
  student: StudenteDTO;
  idInstructor: number;
  idCorsoLaurea: number;
  listGruppiStudio: ListGruppiStudioDTO;
  instructors: SelectDTO[];
  corsiLaurea: SelectDTO[];

  showGroups: boolean;
  ngOnInit(): void {
    super.ngOnInit();
    if (!!this.student.gruppoStudio && this.student.gruppoStudio.active) {
      this.groupsService
        .selectInstructors(this.student.gruppoStudio.sessioneOla.id)
        .subscribe(
          (result) => {
            this.instructors = result.list;
          },
          (error) => {
            console.log('Errore selectInstructors');
          }
        );

      this.sharedService.selectCorsiLaurea().subscribe(
        (result) => {
          this.corsiLaurea = result.list;
        },
        (error) => {
          console.log('Errore selectCorsiLaurea');
        }
      );
      this.showGroups = true;
    } else {
      this.showGroups = false;
    }
  }

  goToGroupDetail(idGruppo: number) {
    this.router.navigate(['/group'], { queryParams: { idGruppo: idGruppo } });
  }

  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  constructor(
    private spinner: NgxSpinnerService,
    public router: Router,
    private sharedService: SharedService,
    private groupsService: GroupsService
  ) {
    super();
  }

  search(idInstructor: number, idCorsoLaurea: number, idSessioneOla: number) {
    this.spinner.show();
    this.groupsService
      .search(idInstructor, idCorsoLaurea, idSessioneOla)
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore search');
        }
      );
  }

  nextPage(skip: number, take: number, count: number) {
    this.spinner.show();
    this.groupsService
      .nextPage(
        this.idInstructor,
        this.idCorsoLaurea,
        Number(this.student.gruppoStudio.sessioneOla.id),
        skip,
        take,
        count
      )
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore search next');
        }
      );
  }

  goToPage(idVaiA: string, event: any) {
    this.spinner.show();
    this.groupsService
      .goToPage(
        this.idInstructor,
        this.idCorsoLaurea,
        this.student.gruppoStudio.sessioneOla.id,
        idVaiA,
        this.listGruppiStudio.take
      )
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search goToPage');
          this.spinner.hide();
        }
      );
  }

  previousPage(skip: number, take: number) {
    this.spinner.show();
    this.groupsService
      .previousPage(
        this.idInstructor,
        this.idCorsoLaurea,
        Number(this.student.gruppoStudio.sessioneOla.id),
        skip,
        take
      )
      .subscribe(
        (result) => {
          this.listGruppiStudio = result;
          this.calcolaListVaiA(this.listGruppiStudio.pages);
          this.idVaiA = '' + (this.listGruppiStudio.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore search previous');
        }
      );
  }
}
